import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './CtaSection.css';

const CtaSection = () => {
  return (
    <section className="cta-section">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <div className="cta-content">
              <h2 className="cta-title">Ready to Transform Your Farm?</h2>
              <p className="cta-text">
                Contact our experts today to discover how our innovative solutions can 
                help you improve productivity, ensure animal welfare, and achieve sustainable growth.
              </p>
              <div className="cta-buttons">
                <Button variant="primary" size="lg" className="me-3 btn-custom">
                  Get Started
                </Button>
                <Button variant="outline-light" size="lg" className="btn-custom-outline">
                  Schedule Consultation
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CtaSection;